import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FacturaRoutingModule } from './factura-routing.module';
import { ListaComponent } from './lista/lista.component';
import { InvoiceComponent } from './invoice/invoice.component';
import { InvoiceUpdComponent } from './invoice-upd/invoice-upd.component';
import { SharedModule } from 'app/shared/shared.module';
import { ClienteComponent } from './cliente/cliente.component';
import { ProductoComponent } from './producto/producto.component';
import { ListaFacturasComponent } from './lista-facturas/lista-facturas.component';
import { ComplementoPagoComponent } from './utilsComprobantePago/complementoPago/complementoPago.component';
import { PagosComponent } from './utilsComprobantePago/pagos/pagos.component';
import { DocsRelacionadosComponent } from './utilsComprobantePago/docsRelacionados/docsRelacionados.component';
import { ImpuestosComplementoComponent } from './utilsComprobantePago/impuestosComplemento/impuestosComplemento.component';
import { DialogNuevoClienteComponent } from 'app/utilerias/nuevo-cliente/dialog-nuevo-cliente.component';
import { FacturaCporteComponent } from 'app/utilerias/factura-cporte/factura-cporte.component';
import { UbicacionesComponent } from 'app/utilerias/ubicaciones/ubicaciones.component';
import { MercanciasComponent } from 'app/utilerias/mercancias/mercancias.component';
import { AutotransporteComponent } from 'app/utilerias/autotransporte/autotransporte.component';
import { TiposFiguraComponent } from 'app/utilerias/tipos-figura/tipos-figura.component';
import { GuiaTransporteComponent } from 'app/utilerias/guia-transporte/guia-transporte.component';
import { GuiaIdentificacionComponent } from 'app/utilerias/guia-identificacion/guia-identificacion.component';

//import { FuseCardModule } from '@fuse/components/card';
import { StripeChargeComponent } from 'app/utilerias/Stripe/stripe-charge/stripe-charge.component';
import { CancelaCFDI4Component } from './cancela-cfdi4/cancela-cfdi4.component';
import { ErrorFacturacionComponent } from './error-facturacion/error-facturacion.component';
import { SuccessFacturacionComponent } from './success-facturacion/success-facturacion.component';
import { TransporteAereoComponent } from 'app/utilerias/transporte-aereo/transporte-aereo.component';
import { PedimentosComponent } from 'app/utilerias/pedimentos/pedimentos.component';
import { FerroviariosComponent } from 'app/utilerias/ferroviarios/ferroviarios.component';
import { DerechosPasoComponent } from 'app/utilerias/derechos-paso/derechos-paso.component';
import { CarroComponent } from 'app/utilerias/carro/carro.component';
import { ContenedorComponent } from 'app/utilerias/contenedor/contenedor.component';
import { MaritimoComponent } from 'app/utilerias/maritimo/maritimo.component';
import { VistaPreviaFacturaComponent } from './vista-previa-factura/vista-previa-factura.component';
import { TwoDigitDecimaNumberDirective } from 'app/utilerias/directives/twodigitdecimalnumber.directive';
import { ContenedorMaritimoComponent } from 'app/utilerias/contenedor-maritimo/contenedor-maritimo.component';
// import { BrowserModule } from '@angular/platform-browser';
import { FuseCardModule } from '@fuse/components/card/card.module';
import { EmailDialog } from '../../modules/factura/lista-facturas/lista-facturas.component';
import { FuseCardComponent } from '@fuse/components/card';
import { DatePipe } from '@angular/common';
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEsMX from '@angular/common/locales/es-MX';
import { MAT_DATE_LOCALE } from '@angular/material/core';

import { DialogNewCfdiComponent } from './dialog-new-cfdi/dialog-new-cfdi.component';
import { ListaImportacionComponent } from './lista-importacion/lista-importacion.component';

import { TableroComponent } from './tablero/tablero.component';
import { DialogCfdiRelacionadosComponent } from './dialog-cfdi-realcionados/dialog-cfdi-realcionados.component';
import { PartesTransporteComponent } from 'app/utilerias/partes-transporte/partes-transporte.component';
import { ImportInvoicesComponent } from './import-invoices/import-invoices.component';


@NgModule({
    declarations: [
        ListaComponent,
        ClienteComponent,
        ProductoComponent,
        InvoiceComponent,
        InvoiceUpdComponent,
        ListaFacturasComponent,
        ComplementoPagoComponent,
        PagosComponent,
        DocsRelacionadosComponent,
        ImpuestosComplementoComponent,
        DialogNuevoClienteComponent,
        FacturaCporteComponent,
        UbicacionesComponent,
        MercanciasComponent,
        TransporteAereoComponent,
        AutotransporteComponent,
        TiposFiguraComponent,
        GuiaTransporteComponent,
        GuiaIdentificacionComponent,
        PedimentosComponent,
        StripeChargeComponent,
        CancelaCFDI4Component,
        ErrorFacturacionComponent,
        SuccessFacturacionComponent,
        FerroviariosComponent,
        DerechosPasoComponent,
        CarroComponent,
        ContenedorComponent,
        MaritimoComponent,
        VistaPreviaFacturaComponent,
        TwoDigitDecimaNumberDirective,
        ContenedorMaritimoComponent,
        EmailDialog,
        DialogNewCfdiComponent,
        ListaImportacionComponent,
        DialogCfdiRelacionadosComponent,
        PartesTransporteComponent,
        ImportInvoicesComponent
    ],
    imports: [
        CommonModule,
        FacturaRoutingModule,
        SharedModule,
        // BrowserModule,
        FuseCardModule
    ],
    providers:[DatePipe,{ provide: LOCALE_ID, useValue: 'es-MX' },{ provide: MAT_DATE_LOCALE, useValue: 'es-MX' },],
})
export class FacturaModule { 
    constructor() {
        registerLocaleData(localeEsMX);
      }
}
